import gql from 'graphql-tag';
import collegeEventLocationFragment from './collegeEventLocationFragment';

export default gql`
  mutation replaceCollegeEventLocation($input: replaceCollegeEventLocationInput!) {
    replaceCollegeEventLocation(input: $input) {
      viewer {
        id
        eventLocations {
          ...CollegeEventLocation
        }
      }
      newCollegeEventLocation {
        ...CollegeEventLocation
      }
    }
  }
  ${collegeEventLocationFragment}
`;
